// util/general.js
import { actions } from "./actions";

let store;
export const injectStoreGeneral = _store => {
  store = _store;
};

export const checkUserRequirement = (
  sqs,
  tos,
  mobileVerified,
  nces,
  navigation,
  setRequirements,
) => {
  if (!mobileVerified) {
    // console.log('not verified');
    // For web, use window.location or any routing library like react-router
    // window.location.href = '/mobile-verification';
  } else if (sqs.length !== 3) {
    // window.location.href = '/security-questions';
  } else if (!tos) {
    // window.location.href = '/tos';
  } else if (nces.length === 0) {
    // window.location.href = '/schools';
  } else {
    setRequirements();
  }
};

export const timeout = ms => new Promise(resolve => setTimeout(resolve, ms));

export const fetchWithToken = async (url, body = null, method = 'POST') => {
  let headers;

  const token = store.getState().auth.token;
  if (token) {
    headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
  }

  const options = {
    method,
    headers,
    body: JSON.stringify(body),
  };

  return fetch(url, options);
};

export const mapDocumentTypeToIcon = documentTypeId => {
  switch (documentTypeId) {
    case 1:
      return '../assets/image/white-aup-icon.png';
    case 2:
      return '../assets/image/white-permission-slip-icon.png';
    case 3:
      return '../assets/image/white-vpc-icon.png';
    case 4:
      return '../assets/image/white-my-docs-icon.png';
    case 5:
      return '../assets/image/white-role-guide-icon.png';
    default:
      return null;
  }
};

const PENDING_COLOR = '#E1AA4B';
const DENIED_COLOR = '#E55151';
const SIGNED_COLOR = '#28A885';
const EXPIRED_COLOR = '#A8A8A8';

export const mapDocumentStatus = (has_responded, has_agreed, is_expired) => {
  if (has_responded == 1) {
    if (has_agreed == 1) {
      return { statusText: 'Signed', statusColor: SIGNED_COLOR };
    } else {
      return { statusText: 'Denied', statusColor: DENIED_COLOR };
    }
  } else {
    if (is_expired == 1) {
      return { statusText: 'Expired', statusColor: EXPIRED_COLOR };
    }
  }
  return { statusText: 'Pending', statusColor: PENDING_COLOR };
};

// For web, you can use window dimensions
export const deviceHeight = window.innerHeight;
export const deviceWidth = window.innerWidth;

export const showErrorModal = (message, options = {}) => {
  if (!store) {
    console.error("Store not injected; cannot display error modal.");
    return;
  }

  const {
    title = "Error",
    confirmLabel,
    status = "Failed",
  } = options;
  store.dispatch({
    type: actions.SHOW_ERROR_MODAL,
    payload: { title, message, confirmLabel, status },
  });
};

export const hideErrorModal = () => {
  if (!store) {
    console.error("Store not injected; cannot hide error modal.");
    return;
  }

  store.dispatch({ type: actions.HIDE_ERROR_MODAL });
};
